/** The line about the tile you stand on: a swatch, its name, and what it is good for or how its machine does. */
import type { JSX } from 'react';

import { factsHere } from '@game/planet/here';
import { useGame, useGameState, useLocale, useTick } from '@ui/hooks';

import { swatch } from '../../art/hexArt';
import { tileText } from './tileText';

export function TileLabel(): JSX.Element | null {
  useLocale();
  const game = useGame();
  useGameState((s) => s.here);
  useGameState((s) => s.planetVersion);
  const facts = factsHere(game);
  // a charge's fuse counts down, an infuser's lay too
  const role = facts?.machine?.role;
  useTick(role === 'charge' ? 250 : role === 'infuser' ? 1000 : null);
  if (!facts) return null;
  const text = tileText(facts);
  return (
    <div className="tile-l glass" role="status" aria-live="polite">
      <span className="sw" style={{ background: swatch(facts.kind, facts.group) }} />
      <span>
        <b className={facts.group ? 'grp' : undefined}>{text.title}</b>
        {text.hint && ` · ${text.hint}`}
      </span>
    </div>
  );
}
